import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, useTheme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { userService } from '../../../shared/services/users/usersServices';
import { useResident } from '../context/useResident';
import { PageHeader } from '../components/ResidentDetail/PageHeader';
import { ActionButtons } from '../components/ResidentDetail/ActionButtons';
import { ResidentInfo } from '../components/ResidentDetail/ResidentInfo';
import { ModalDelete } from '../components/ModalDelete';


export default function ResidentDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const theme = useTheme();
  const { 
    openDeleteModal, 
    isDeleteModalOpen, 
    closeDeleteModal, 
    handleDeleteResident, 
    isDeleting, 
    navigateToEdit 
  } = useResident();

  const { data, isLoading } = useQuery({
    queryKey: ['resident', id],
    queryFn: () => userService.get(id!).then(res => res.data),
    enabled: !!id
  });

  if (isLoading) return null;
  if (!data) return null;

  return (
    <Box sx={{ 
      p: { xs: 1, md: 4 }, 
      background: theme.palette.background.default, 
      minHeight: '100vh' 
    }}>
      <Box sx={{ 
        background: theme.palette.background.paper, 
        borderRadius: 4, 
        p: 4, 
        maxWidth: 1200, 
        margin: '0 auto',
        boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)' 
      }}>
        <PageHeader onBack={() => navigate(-1)} />
        
        <ActionButtons 
          onEdit={() => navigateToEdit(data.id)}
          onDelete={() => openDeleteModal(data)}
        />
        
        <ResidentInfo resident={data} />
      </Box>

      <ModalDelete
        open={isDeleteModalOpen}
        onClose={closeDeleteModal}
        onConfirm={handleDeleteResident}
        loading={isDeleting}
        residentName={data?.name || ''}
      />
    </Box>
  );
}